import React from "react";
import { toast, TOAST_POSITION } from "../../../../components/material/ToastPopup";
import styles from "./DirectShareModal.module.scss";
import { OV_STRINGS } from "../../constants/strings";

function DirectShareModal({ isOpen, linkUrl, officeName, onClose }) {
  if (!isOpen) return null;

  const message = OV_STRINGS.DIRECT_SHARE_MESSAGE(linkUrl, officeName);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(message);
    } catch {
      const textarea = document.createElement("textarea");
      textarea.value = message;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }
    toast.success(OV_STRINGS.DIRECT_SHARE_TOAST, {
      position: TOAST_POSITION.BOTTOM_CENTER,
    });
    onClose?.();
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ text: message });
        onClose?.();
      } catch {}
    } else {
      handleCopy();
    }
  };

  const handleOverlay = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <>
      <div className={styles.overlay} onClick={handleOverlay} />
      <div className={styles.pos}>
        <div className={styles.modal}>

          <div className={styles.header}>
            <h3 className={styles.title}>
              {OV_STRINGS.DIRECT_SHARE_MODAL_TITLE.split('\n').map((line, i) => (
                <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
              ))}
            </h3>
            <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="닫기">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6l12 12" stroke="#171719" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </button>
          </div>

          <div className={styles.messageArea}>
            <div className={styles.messageBox}>
              {message}
            </div>
          </div>

          <div className={styles.actions}>
            <button type="button" className={styles.copyBtn} onClick={handleCopy}>
              {OV_STRINGS.DIRECT_SHARE_COPY}
            </button>
            <button type="button" className={styles.shareBtn} onClick={handleShare}>
              {OV_STRINGS.DIRECT_SHARE_SHARE}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default DirectShareModal;
